<template>
  <Popper placement="right">
    <span v-show="!task.inputMode" role="button" :style="`color: ${this.iconColor};`" @click="this.fetchChanges()" class="px-2">
      <i class="fa-solid fa-clock"></i>
    </span>
    <template #content>
      <h5 class="text-center">Historia zmian</h5>
      <div class="separate-line"></div>
      <div class="change-list" ref="changeList">
          <div class="change-list__change" v-for="(change, i) in changes" :key="i">
            <div class="change-list__change__content">
              <strong class="change-list__change__content__time" ref="time">
                {{ moment(change.timestamp).tz('Europe/Warsaw').format('DD.MM.YYYY HH:mm:ss') }} <br> {{change.changedBy}}
              </strong>
              <span class="change-list__change__content__after-change" style="display:block" ref="after">{{change.oldValue}}</span>
              <img src="../assets/caret-down.svg" alt="V">
              <span class="change-list__change__content__before-change" style="display: block;" ref="before">{{change.newValue}}</span>
            </div>
          </div>
        <div class='alert-container' ref="alertContainer"></div>
      </div>
      <!-- <button @click="this.tst()">tst</button> -->
    </template>
  </Popper>
</template>

<script>
import Popper from 'vue3-popper'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment-timezone'
export default {
  name: 'ChangesPreview',
  components: { Popper },
  props: ['task', 'prop'],
  data(){
    return {
      iconColor: '',
      taskChangelog: null,
      changes: []
    }
  },
  mounted() {

  },
  methods: {
    moment,
    fetchChanges(){
      // this.$refs.changeList.innerHTML = ''
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.get(`${process.env.VUE_APP_API_BASE_URL}ChangeLog/Tasks/${this.task.id}/${this.prop}`, config)
        .then(re => {
          if(re.data.length == 0){
            this.showAlert()
          }else{
            this.changes = re.data
          }
        })
        .catch(er => {
          console.log(er)
        })
    },
    showAlert(){
      this.$refs.alertContainer.innerHTML = '<strong>Brak zmian</strong>'
    }
  },
}
</script>

<style scoped>
.change-list{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  max-width: 350px;
}
.change-list__change{
  border-bottom:  1px solid black;
  padding: 5px 0;
}

.change-list__change__content__before-change{
  background-color: #85cd96;
  border: 1px solid #28a745;
  padding: 5px 10px;
  border-radius: 6px;
}

.change-list__change__content__after-change{
  background-color: #ffde7b;
  border: 1px solid #ffc107;
  padding: 5px 10px;
  border-radius: 6px;
}
.alert-container{
  width: 300px;
  background-color: rgb(193, 10, 10);
}
</style>
